import React, {useState} from 'react';
import {AddShoppingCart} from '@mui/icons-material';
import {CircularProgress} from '@mui/material';
import {toast} from 'react-toastify';
import {buildWithoutDeal} from '../domain/ProductSelection.model';
import {untrackProduct} from '../infrastructure/productApi';
import {useCartContext} from '../../cart/context/CartContext';
import {useComercialContext} from '../../comercial/ComercialContext';

/**
 * Añade al carrito un producto pendiente que vuelve a tener stock,
 * con la cantidad que el cliente quería, y lo quita de pendientes.
 *
 * @param {{
 *     product: Object,
 *     onAdded?: (code: string) => void,
 *     onFailed?: () => void,
 * }} props product es el ProductDto de pendientes (con trackedQuantity)
 */
export const AddRestockedToCartButton = ({product, onAdded, onFailed}) => {
    const [loading, setLoading] = useState(false);
    const {addProduct} = useCartContext();
    const {actingAsCliente} = useComercialContext();

    const quantity = product.trackedQuantity ?? 1;

    const handleClick = async (event) => {
        event.stopPropagation();
        setLoading(true);
        try {
            await addProduct(buildWithoutDeal(product, quantity));
            toast.success(`${product.name} añadido al carrito (${quantity} ud.)`);
            try {
                await untrackProduct(product.code, actingAsCliente?.numCliente);
            } catch (error) {
                console.error('Failed to untrack product after adding to cart:', error);
            }
            onAdded?.(product.code);
        } catch (error) {
            console.error('Failed to add restocked product to cart:', error);
            toast.error('No se pudo añadir al carrito. Puede que se haya agotado el stock.');
            onFailed?.();
        } finally {
            setLoading(false);
        }
    };

    return (
        <button type="button"
            className="btn btn-primary d-flex align-items-center justify-content-center gap-1 w-100"
            onClick={handleClick}
            disabled={loading}>
            {loading ? <CircularProgress size={20}/> : <AddShoppingCart/>}
            Añadir al carrito
        </button>
    );
};
